import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl: any;

  role: any;

  route_url = '';

  constructor(private http: HttpClient, private router: Router) {
    this.baseUrl = environment.apiUrl;
  }

  getLoginDetail(user) {
    return this.http.post(`${this.baseUrl}/api/users/login`, user);
  }

  createUser(user) {
    return this.http.post(`${this.baseUrl}/api/users`, user);
  }

  arrayOfObjectMapping(key, documentRecords) {
    const currentMappedItemStatus: any = {};
    if (documentRecords) {
      for (let i = 0; i < documentRecords.length; i += 1) {
        if (documentRecords[i]) {
          if (currentMappedItemStatus.hasOwnProperty(documentRecords[i][key])) {
            currentMappedItemStatus[documentRecords[i][key]].push(documentRecords[i]);
          } else {
            currentMappedItemStatus[documentRecords[i][key]] = [documentRecords[i]];
          }
        }
      }
    }
    return currentMappedItemStatus;
  }

  async isLoggedIn(url): Promise<boolean> {
    try {
      this.route_url = url;
      if (!this.getCookie('accessToken')) {
        this.router.navigate(['/auth/signin']);
        return false;
      }

      return true;
    } catch (err) {
      console.log('err is is logged in check', err);
      return false;
    }
  }

  getCookie(cname) {
    return localStorage.getItem(cname);
  }
}
